/*
 * Suggestion lists on text inputs, on the native <datalist>, replacing the
 * jQuery UI autocomplete widget. The server renders value-type-aware controls
 * with data-autocomp="a,b,c"; the enhancer below turns that into a datalist
 * and removes the attribute, which is also what stops the un-migrated jQuery
 * code from building a second widget over the same input.
 */
let sequence = 0;

export function attachDatalist(input: HTMLInputElement, values: readonly string[]): HTMLDataListElement {
    let list = input.list instanceof HTMLDataListElement ? input.list : null;
    if (!list) {
        list = document.createElement('datalist');
        list.id = `mcp-datalist-${++sequence}`;
        input.after(list);
        input.setAttribute('list', list.id);
        input.setAttribute('autocomplete', 'off');
    }
    list.replaceChildren(...values.map(value => {
        const option = document.createElement('option');
        option.value = value;
        return option;
    }));
    return list;
}

/** Comma-separated data-autocomp values, trimmed, empties dropped. */
export function parseAutocomp(raw: string | null | undefined): string[] {
    return (raw ?? '').split(',').map(s => s.trim()).filter(Boolean);
}

export function enhanceAutocompletes(root: ParentNode): void {
    const inputs = root instanceof HTMLInputElement && root.hasAttribute('data-autocomp')
        ? [root]
        : Array.from(root.querySelectorAll<HTMLInputElement>('input[data-autocomp]'));
    for (const input of inputs) {
        const values = parseAutocomp(input.getAttribute('data-autocomp'));
        input.removeAttribute('data-autocomp');
        if (values.length) attachDatalist(input, values);
    }
}
